export default "__VITE_ASSET__CjU738Xs__"